const integer = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 })
const oneDecimal = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })

/** "1.234" */
export const formatInt = (n: number): string => integer.format(n)

/** "1.234 €", whole euros: the dashboard shows totals, not cents. */
export const formatEuro = (n: number): string => `${integer.format(Math.round(n))} €`

/** "12,5 Std." from hours. */
export const formatHours = (hours: number): string => `${oneDecimal.format(hours)} Std.`

/** "12,5 Std." from minutes. */
export const formatHoursFromMinutes = (minutes: number): string => formatHours(minutes / 60)

/** "78 %" */
export const formatPercent = (n: number): string => `${integer.format(Math.round(n))} %`
